define('configuration/navigation.configuration',['require','exports','module','underscore','fukit','navigation'],function(require, exports, module) {
  //prettier-ignore
  var _               = require('underscore'),
      FuKit           = require('fukit'),
      localNavigation = require('navigation');

  var LocalNavigationConfiguration = _.extend({}, FuKit.NavigationConfiguration, {
    options: {
      navigation: localNavigation,
    },
  });

  module.exports = LocalNavigationConfiguration;
});

